module.exports = __webpack_public_path__ + "static/media/BESS.f00d2aa4.jpg";